import React, { useState, useEffect, useRef } from "react";

import {
    Grid,
    TextField,
    MenuItem,
    Typography,
    Select,
    Avatar,
    Button,
} from "@material-ui/core";

export default (props) => {
    const [profile, setProfile] = useState(props.profile);
    const [toolboxTypes, setToolboxTypes] = useState(props.toolboxTypes);
    const [localIconURL, setLocalIconURL] = useState(false);
    const ref = useRef();
    useEffect(() => {
        setProfile(props.profile);
        setToolboxTypes(props.toolboxTypes);
    }, [props.profile, props.toolboxTypes]);

    const renderText = (label, key, multiline = false) => {
        if (props.pageType !== "view") {
            return (
                <div style={{ display: "flex", marginBottom: 30 }}>
                    <Typography variant="title" style={{ width: 150 }}>
                        {label}:
                    </Typography>
                    <TextField
                        disabled={key === "job_type"}
                        rows={multiline ? 2 : 1}
                        rowsMax={multiline ? 4 : 1}
                        multiline={multiline}
                        style={{ width: "70%", marginLeft: 20 }}
                        value={profile[key]}
                        onChange={(event) => {
                            props.setData(key, event.target.value);
                        }}
                    />
                </div>
            );
        } else {
            return (
                <div
                    style={{
                        display: "flex",
                        marginBottom: 30,
                        marginLeft: 24,
                    }}
                >
                    <Typography style={{ width: 200 }} variant="title">
                        <b>{label}:</b>
                    </Typography>
                    <Typography style={{ marginLeft: 24 }} variant="subheading">
                        {profile[key]}
                    </Typography>
                </div>
            );
        }
    };
    const renderDropDown = (label, key, opts) => {
        if (props.pageType !== "view") {
            return (
                <div style={{ display: "flex", marginBottom: 30 }}>
                    <Typography variant="title" style={{ width: 150 }}>
                        {label}:
                    </Typography>
                    <Select
                        // multiple
                        style={{ width: "70%", marginLeft: 20 }}
                        value={profile[key] === "" ? "N/A" : profile[key]}
                        onChange={(event) => {
                            props.setData(key, event.target.value);
                        }}
                    >
                        {opts.map((option) => {
                            return (
                                <MenuItem value={option} key={option}>
                                    {option}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </div>
            );
        } else {
            return (
                <div
                    style={{
                        display: "flex",
                        marginBottom: 30,
                        marginLeft: 24,
                    }}
                >
                    <Typography style={{ width: 200 }} variant="title">
                        <b>{label}:</b>
                    </Typography>
                    <Typography style={{ marginLeft: 40 }} variant="subheading">
                        {!profile[key]
                            ? ""
                            : typeof profile[key] === "object"
                            ? profile[key].map((e) => {
                                  return <span>{e + ", "}</span>;
                              })
                            : profile[key]}
                    </Typography>
                </div>
            );
        }
    };

    return (
        <Grid item xl={12} xs={12}>
            <Typography
                style={{ marginLeft: 24, marginBottom: 30 }}
                variant="h5"
            >
                Toolbox Talks Details:
            </Typography>
            <div style={{ marginLeft: 24 }}>
                <Avatar
                    style={{
                        width: 100,
                        height: 100,

                        borderRadius: "12px",
                        border: "2px solid #0188cc",
                        marginBottom: 24,
                    }}
                    variant="rounded"
                    src={localIconURL ? localIconURL : profile.icon_url}
                    alt=""
                />

                <input
                    type="file"
                    id="file"
                    accept="image/*"
                    ref={ref}
                    style={{ display: "none" }}
                    onChange={(event) => {
                        if (event.target.files[0].size < 1000000) {
                            props.setData("icon_url", event.target.files[0]);
                            setLocalIconURL(
                                URL.createObjectURL(event.target.files[0])
                            );
                        }
                    }}
                />
                {props.pageType !== "view" && (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            ref.current.click();
                        }}
                        style={{
                            marginBottom: 24,

                            color: "white",
                            background: "#0188cc",
                        }}
                    >
                        Add Topic Icon
                    </Button>
                )}
            </div>
            {renderText("Topic Name", "toolbox_topic", false)}
            {renderDropDown("Category", "category", toolboxTypes)}
        </Grid>
    );
};
